import PageHeaderCompact from '@/components/common/PageHeaderCompact.jsx';

export default function AdminPageHeader({
  title,
  breadcrumbs = [],
  description,
  action,
  children,
  showBreadcrumb = false,
}) {
  return (
    <PageHeaderCompact
      title={title}
      description={description}
      breadcrumbs={breadcrumbs}
      showBreadcrumb={showBreadcrumb}
      action={action}
    >
      {children}
    </PageHeaderCompact>
  );
}
